import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';

import styles from 'src/app/projects/views/new-project-definition/NewProjectDefinition.module.scss';
import useProjectDefinition from 'src/app/projects/views/new-project-definition/hooks/useProjectDefinition';
import CompletionBadge from 'src/shared/components/completion-badge/CompletionBadge';
import ListOfErrors from 'src/shared/components/list-of-errors/ListOfErrors';
import SampleGroups from './components/sample-groups/SampleGroups';
import HabitatAssayTypes from './components/habitat-assay-types/HabitatAssayTypes';
import { getSectionErrors } from '../../helpers/sectionValidation';
import { getSectionStatus } from '../../helpers/sectionCompletion';

export const ProjectAims = () => {
    const { formState } = useProjectDefinition();
    const errors = getSectionErrors(formState, 'projectAims');
    const status = getSectionStatus(formState, 'projectAims');

    return (
        <div className={styles.formView}>
            <div className={styles.formViewTitle}>
                <span>Project target</span>
                <div className={styles.sectionStatus}>
                    {status.isComplete && <CheckCircle className={styles.completeIcon} />}
                    {status.hasErrors && <AlertCircle className={styles.errorIcon} />}
                    <CompletionBadge completedFields={status.completedFields} totalFields={status.totalFields} />
                </div>
            </div>
            <SampleGroups />
            <HabitatAssayTypes />
            <ListOfErrors errors={errors} className={styles.formSection} />
        </div>
    );
};

export default ProjectAims;
